import React from "react"

import lombardi from '../../../../assets/coaches/lombardi-trophy.png'
import conf from '../../../../assets/coaches/conference-trophy.png'
import playoff from '../../../../assets/coaches/playoff-birth.png'

const ImageX = ({ val, imageType }) => {

    // dict of image and array params //
    const imageDict = {
        'lombardi' : {
            'asset' : lombardi,
            'width' : '12px'
        },
        'conf' : {
            'asset' : conf,
            'width' : '12px'
        },
        'playoff' : {
            'asset' : playoff,
            'width' : '12px'
        },
    }

    // get number to loop //
    const valNum = parseInt(val)
    if (isNaN(valNum) || valNum === 0) {
        // return empty array if value is 0 //
        return (
            <div style={{
                display : 'flex',
                flexWrap : 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'calc(100% - 20px)',
                padding: '10px',
                color: 'grey'
            }}>
                --
            </div>
        )
    }

    return (
        // wrapper of all team badges //
        <div style={{
            display : 'flex',
            flexWrap : 'no-wrap',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'calc(100% - 20px)',
            padding: '10px',
        }}>
            <img
                style={{
                    width: imageDict[imageType]['width'],
                    height: 'auto',
                    marginRight: '7px'
                }}
                src={imageDict[imageType]['asset']}
                alt={`nfl ${imageType} trophy`}
            />
            <p
                style={{
                    fontSize: '0.75rem',
                    padding: '0px',
                    margin: '0px 2px 0px 0px'
                }}
                    
            >
                x
            </p>
            <p
                style={{
                    fontSize: '.9rem',
                    padding: '0px',
                    margin: '0px 5px 0px 0px',
                    fontWeight: '500'
                }}
                    
            >
                {valNum}
            </p>
        </div>

    )
    
}

export default ImageX